exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".adSense{position:fixed;bottom:-5px;left:0;z-index:1000;width:100%;text-align:center}.adSense-transparent{position:absolute;opacity:.7;background-color:#c76b00;width:100%;height:100%}.adSense-close{position:absolute;right:5px;top:5px;font-size:25px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/components/adSense/adSense.styl
// module id = 788
// module chunks = 0